import { render } from "./md-arrow-forward.vue?vue&type=template&id=a462c85e"
import script from "./md-arrow-forward.vue?vue&type=script&lang=js"
export * from "./md-arrow-forward.vue?vue&type=script&lang=js"
script.render = render

export default script